import { InstagramEventRemapped } from './instagram-event';
import { QualifioEngageCampaignEventPayload } from './engage-event-payload';

export interface PredictionEventPayload {
  timestamp: string;
  matchExternalId: string;
  leagueExternalId: string;
  result: PredictionResult;
  contextId: string;
  gameUuid: string;
}

export type EarnEventPayload =
  | QualifioEngageCampaignEventPayload
  | EcommerceEventPayload
  | BinaryBasicEventPayload
  | QualifioLoyaltyProfileCreationEventPayload
  | QualifioLoyaltyLevelEventPayload
  | QualifioLoyaltyMemberVisitEventPayload
  | PredictionEventPayload
  | InstagramEventRemapped;

export interface EventEnveloppe<T extends EarnEventPayload> {
  id: string;
  payload: T;
  taskId: number;
  createdAt: string;
  updatedAt: string;
}

export interface BinaryBasicEventPayload {
  timestamp: string;
  origin?: string;
  label?: string;
  value?: string;
  tags?: { name: string; value: unknown }[];
  counters?: { name: string; value: number }[];
  formattedTags?: { [key: string]: string };
  formattedCounters?: { [key: string]: number };
}

export interface EcommerceEventPayload {
  amountVatExcluded?: number;
  amountVatIncluded?: number;
  shippingCostVatIncluded?: number;
  totalAmountVatIncluded?: number;
  currency?: string;
  basket?: EcommerceEventPayloadBasket;
  basketTotal?: number;
  quantityTotal?: number;
  timestamp: string;
  couponUsed?: { code: string }[];
  tags: { name: string; value: unknown }[];
  referralCode?: string;
}

export interface EcommerceEventPayloadBasket {
  productName?: string;
  productCode?: string;
  productVatExcluded?: number;
  productVatIncluded?: number;
  quantity?: number;
}

export interface QualifioLoyaltyProfileCreationEventPayload {
  timestamp: string;
  referralCode?: string;
}

export interface QualifioLoyaltyLevelEventPayload {
  levelId: string;
  timestamp: string;
}

export interface QualifioLoyaltyMemberVisitEventPayload {
  previousVisit: string;
  consecutiveDailyVisits: number;
  totalDailyVisits: number;
  timestamp: string;
}

export interface QualifioLoyaltyMemberClickEventPayload {
  buttonId: string;
  timestamp: string;
}

export interface QualifioLoyaltyBirthdayEventPayload {
  age: number;
  timestamp: string;
}

export enum CampaignType {
  'ADVENT_CALENDAR' = 'Advent calendar',
  'ANIMATED_GAME' = 'Animated game',
  'BATTLE' = 'Battle',
  'CHECKLIST' = 'Checklist',
  'CHRONO_QUIZ' = 'Chrono quiz',
  'CUMULATIVE_QUIZ' = 'Cumulative quiz',
  'FORM' = 'Form',
  'GUESS_THE_WORD' = 'Guess the word',
  'INSTANT_WIN' = 'Instant win',
  'JACKPOT' = 'Jackpot',
  'LANDING_PAGE' = 'Landing page',
  'MEMORY' = 'Memory',
  'ONE_PAGE_PERSONALITY_TEST_WITH_IMAGES' = 'One page personality test with images',
  'ONE_PAGE_POLL_WITH_IMAGES' = 'One page poll with images',
  'ONE_PAGE_QUIZ_WITH_IMAGES' = 'One page quiz with images',
  'PERSONALITY_TEST' = 'Personality test',
  'PERSONALITY_TEST_WITH_BRANCHING' = 'Personality test with branching',
  'PHOTO_CONTEST_UPLOAD' = 'Photo contest upload',
  'PHOTO_CONTEST_VOTE' = 'Photo contest vote',
  'POLL' = 'Poll',
  'PREDICTION' = 'prediction',
  'PROMOTIONAL_POP_UP' = 'Promotional popup',
  'PUZZLE' = 'Puzzle',
  'QUIZ' = 'Quiz',
  'SLIDING_PUZZLE' = 'Sliding puzzle',
  'SUDDEN_DEATH' = 'Sudden death',
  'SURVEY' = 'Survey',
  'SURVEY_WITH_BRANCHING' = 'Survey with branching',
  'SWIPER_PERSONALITY_TEST' = 'Swiper personality test',
  'SWIPER_POLL' = 'Swiper poll',
  'SWIPER_QUIZ' = 'Swiper quiz',
  'TEAM_SELECTOR' = 'Team selector',
  'VIDEO_CONTEST_UPLOAD' = 'Video contest upload',
  'VIDEO_CONTEST_VOTE' = 'Video contest vote',
  'WHEEL_OF_FORTUNE' = 'Wheel of fortune',
  'WRITING_CONTEST_UPLOAD' = 'Writing contest upload',
  'WRITING_CONTEST_VOTE' = 'Writing contest vote',
  //'NONE' = 'NONE',
  //'UNKNOWN' = 'UNKNOWN',
}

export enum PredictionResult {
  'INCORRECT' = 'INCORRECT',
  'CORRECT_WINNER' = 'CORRECT_WINNER',
  'CORRECT_SCORE' = 'CORRECT_SCORE',
}
